module.exports = __webpack_public_path__ + "img/6.d7cc9ea9.png";